const sections = `<div class="d-flex d-lg-none align-items-center justify-content-end mb-10">
<div class="d-flex align-items-center gap-2">
    <div class="btn btn-icon btn-active-color-primary w-30px h-30px" id="kt_social_start_sidebar_toggle">
        <i class="ki-outline ki-profile-circle fs-1"></i>        </div>

    <div class="btn btn-icon btn-active-color-primary w-30px h-30px" id="kt_social_end_sidebar_toggle">
        <i class="ki-outline ki-scroll fs-1"></i>        </div>
</div>
</div>`;


const view = /*html*/`

    <!--begin::Container-->
    <div id="kt_content_container" class="container-xxl">
        <div class="d-flex flex-row">
            <div class="d-lg-flex flex-column flex-lg-row-auto w-lg-325px">
                <div class="card mb-5 mb-xl-8">
                    <!--begin::Header-->
                    <div class="card-header border-0 pt-5">
                        <h3 class="card-title align-items-start flex-column">
                            <span class="card-label fw-bold text-gray-900">Suggestions for you</span>
                            <span class="text-muted mt-1 fw-semibold fs-7">8k social visitors</span>
                        </h3>                        
                    </div>
                    <!--end::Header-->
                    <!--begin::Body-->
                    <div class="card-body pt-5">
                        
                    </div>
                    <!--end::Body-->
                </div>
            </div>
            <div class="w-100 flex-lg-row-fluid mx-lg-13">                
                <div class="card card-flush mb-10 feed-new-post d-none">
                    <!--begin::Header-->
                    <div class="card-header justify-content-start align-items-center pt-4">
                        <!--begin::Photo-->
                        <div class="symbol symbol-45px me-5">
                            <img class="user-img" id="feed-new-post-avatar" src="assets/media/avatars/default.jpg" class="" alt="">
                        </div>
                        <!--end::Photo-->
                        <span class="text-gray-500 fw-semibold fs-6">What’s on your mind?</span>
                    </div>
                    <!--end::Header-->
                    <!--begin::Body-->
                    <div class="card-body pt-2 pb-0">
                        <!--begin::Input-->
                        <!--<textarea class="form-control form-control-solid ps-5 border-0 fw-normal" id="social-post-input" name="" data-kt-autosize="true" rows="2" placeholder="Publish for the community and friends..." style="overflow: hidden; overflow-wrap: break-word; resize: none; text-align: start; height: 63px;"></textarea>-->
                        <!--<div id="social-post-input" class="form-control form-control-solid p-0 border-0 fw-normal" contenteditable="true" data-kt-autosize="true" placeholder="Publish for the community and friends..." style="overflow: hidden; overflow-wrap: break-word; resize: none; text-align: start; height: 63px;"></div>-->
                        <div id="social-post-input" class="form-control form-control-solid p-0 border-0 fw-normal min-h-65px"></div>
                        <!--end::Input-->
                        <div class="d-flex flex-column align-items-center justify-content-center w-100 h-100 my-2">
                            <div class="position-relative h-100 mw-100 rounded overflow-hidden" id="imagePreview" style="background-color:#1b1b1b;"></div>
                            <div class="position-relative h-100 w-100 rounded overflow-hidden" id="videoPreview" style="background-color:#1b1b1b;"></div>
                        </div>
                    </div>
                    <!--end::Body-->
                    <!--begin::Footer-->
                    <div class="card-footer d-flex justify-content-between pt-4 pb-8">
                        <input type="file" id="imageInput" style="display: none;" accept="image/*">
                        <div class="d-flex flex-row gap-1">
                            <div class="d-flex">
                                <button class="btn btn-sm btn-icon btn-active-icon-zgreen btn-active-text-gray-900 py-2" id="social-image-btn">
                                    <i class="fal fa-image fs-2"></i>                                    
                                </button>
                            </div>
                            <div class="d-flex">
                                <button class="btn btn-sm btn-icon btn-active-icon-zyellow btn-active-text-gray-900 py-2 emoji-btn" emoji-textarea="#social-post-input">
                                    <i class="fal fa-smile fs-2"></i>                                    
                                </button>
                            </div>
                        </div>
                        <div class="d-flex">
                            <button class="btn btn-sm btn-primary btn-active-icon-secondary py-2" id="social-image-post">
                                <!--begin::Indicator label-->
                                <span class="indicator-label">Post</span>
                                <!--end::Indicator label--> 
                                <!--begin::Indicator progress-->
                                <span class="indicator-progress"> Please wait... <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                                <!--end::Indicator progress-->
                            </button>
                        </div>
                    </div>
                    <!--end::Footer-->
                </div>

                <div class="d-flex align-items-center justify-content-start mb-6">
                    <span class="rotate cursor-pointer text-uppercase rounded px-3 py-1" data-kt-rotate="true" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-start" data-kt-menu-attach="parent" style="background-color:#1F1F1F;">
                        <span>News</span>
                        <i class="fas fa-chevron-down fs-6 rotate-180 ms-3 me-0 text-gray-800"></i>
                    </span>
                    <div id="social-main-menu" class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-auto min-w-200 mw-300px" style="" data-popper-placement="bottom-start">
                        <!--begin::Menu item-->
                        <div class="menu-item px-3">
                            <div class="menu-content fs-6 text-gray-900 fw-bold px-3 py-4">Select feed</div>
                        </div>
                        <!--end::Menu item-->
                        <!--begin::Menu separator-->
                        <div class="separator mb-3 opacity-75"></div>
                        <div class="menu-item px-3">
                            <span href="#" class="menu-link px-3"> News </span>
                        </div>
                        <div class="menu-item px-3">
                            <span href="#" class="menu-link px-3"> Latest Publications </span>
                        </div>
                        <div class="menu-item px-3 mb-4">
                            <span href="#" class="menu-link px-3"> Friends </span>
                        </div>
                        <!--end::Menu item-->
                    </div>
                </div>

                <div class="mb-10" id="">
                    <div class="card card-flush mb-10">
                        <!--begin::Card header-->
                        <div class="card-header pt-9">
                            <!--begin::Author-->
                            <div class="d-flex align-items-center">
                                <!--begin::Avatar-->
                                <div class="symbol symbol-50px me-5">
                                    <img src="assets/media/avatars/default.jpg" class="" alt="">
                                </div>
                                <!--end::Avatar-->
                                <!--begin::Info-->
                                <div class="flex-grow-1">
                                    <!--begin::Name-->
                                    <a href="#" class="text-gray-800 text-hover-primary fs-4 fw-bold">Brooklyn Simmons</a>
                                    <!--end::Name-->
                                    <!--begin::Date-->
                                    <span class="text-gray-500 fw-semibold d-block">Yestarday at 5:06 PM</span>
                                    <!--end::Date-->
                                </div>
                                <!--end::Info-->
                            </div>
                            <!--end::Author-->
                            <!--begin::Card toolbar-->
                            <div class="card-toolbar">
                                <!--begin::Menu wrapper-->
                                <div class="m-0">
                                    <!--begin::Menu toggle-->
                                    <button class="btn btn-icon btn-color-gray-500 btn-active-color-primary me-n4" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">
                                        <i class="ki-outline ki-dots-square fs-1"></i>
                                    </button>
                                    <!--end::Menu toggle-->
                                </div>
                                <!--end::Menu wrapper-->
                            </div>
                            <!--end::Card toolbar-->
                        </div>
                        <!--end::Card header-->
                        <!--begin::Card body-->
                        <div class="card-body">
                            <!--begin::Post content-->
                            <div class="fs-6 fw-normal text-gray-700"> You can either decide on your final headline before outstanding you write the most of the rest of your creative post </div>
                            <!--end::Post content-->
                        </div>
                        <!--end::Card body-->
                        <!--begin::Card footer-->
                        <div class="card-footer pt-0">
                            <!--begin::Info-->
                            <div class="mb-6">
                                <!--begin::Separator-->
                                <div class="separator separator-solid"></div>
                                <!--end::Separator-->
                                <!--begin::Nav-->
                                <ul class="nav py-3">
                                    <!--begin::Item-->
                                    <li class="nav-item">
                                        <a class="nav-link btn btn-sm btn-color-gray-600 btn-active-color-primary btn-active-light-primary fw-bold px-4 me-1 collapsible " data-bs-toggle="collapse" href="#kt_social_feeds_comments_2">
                                            <i class="ki-outline ki-message-text-2 fs-2 me-1"></i> 3 Comments </a>
                                    </li>
                                    <!--end::Item-->
                                    <!--begin::Item-->
                                    <li class="nav-item">
                                        <a href="#" class="nav-link btn btn-sm btn-color-gray-600 btn-active-color-primary fw-bold px-4 me-1">
                                            <i class="ki-outline ki-heart fs-2 me-1"></i> 8 Likes </a>
                                    </li>
                                    <!--end::Item-->
                                    <!--begin::Item-->
                                    <li class="nav-item">
                                        <a href="#" class="nav-link btn btn-sm btn-color-gray-600 btn-active-color-primary fw-bold px-4">
                                            <i class="ki-outline ki-bookmark fs-2 me-1"></i> 47k Saves </a>
                                    </li>
                                    <!--end::Item-->
                                </ul>
                                <!--end::Nav-->
                                <!--begin::Separator-->
                                <div class="separator separator-solid mb-1"></div>
                                <!--end::Separator-->
                                <!--begin::Comments-->
                                <div class="collapse " id="kt_social_feeds_comments_2"></div>
                                <!--end::Collapse-->
                            </div>
                            <!--end::Info-->
                            <!--begin::Comment form-->
                            <div class="d-flex align-items-center">
                                <!--begin::Author-->
                                <div class="symbol symbol-35px me-3">
                                    <img src="assets/media/avatars/default.jpg" alt="">
                                </div>
                                <!--end::Author-->
                                <!--begin::Input group-->
                                <div class="position-relative w-100">
                                    <!--begin::Input-->
                                    <textarea type="text" class="form-control form-control-solid border ps-5" rows="1" name="search" value="" data-kt-autosize="true" placeholder="Write your comment.." style="overflow: hidden; overflow-wrap: break-word; resize: none; text-align: start; height: 44px;"></textarea>
                                    <!--end::Input-->
                                    <!--begin::Actions-->
                                    <div class="position-absolute top-0 end-0 translate-middle-x mt-1 me-n14">
                                        <!--begin::Btn-->
                                        <button class="btn btn-icon btn-sm btn-color-gray-500 btn-active-color-primary w-25px p-0">
                                            <i class="ki-outline ki-paper-clip fs-2"></i>
                                        </button>
                                        <!--end::Btn-->
                                        <!--begin::Btn-->
                                        <button class="btn btn-icon btn-sm btn-color-gray-500 btn-active-color-primary w-25px p-0">
                                            <i class="ki-outline ki-like fs-2"></i>
                                        </button>
                                        <!--end::Btn-->
                                        <!--begin::Btn-->
                                        <button class="btn btn-icon btn-sm btn-color-gray-500 btn-active-color-primary w-25px p-0">
                                            <i class="ki-outline ki-badge fs-2"></i>
                                        </button>
                                        <!--end::Btn-->
                                        <!--begin::Btn-->
                                        <button class="btn btn-icon btn-sm btn-color-gray-500 btn-active-color-primary w-25px p-0">
                                            <i class="ki-outline ki-geolocation fs-2"></i>
                                        </button>
                                        <!--end::Btn-->
                                    </div>
                                    <!--end::Actions-->
                                </div>
                                <!--end::Input group-->
                            </div>
                            <!--end::Comment form-->
                        </div>
                        <!--end::Card footer-->
                    </div>
                </div>
            </div>
            <div class="d-lg-flex flex-column flex-lg-row-auto w-lg-325px">
                <div class="card mb-5 mb-xl-8">
                    <!--begin::Header-->
                    <div class="card-header border-0 pt-5">
                        <h3 class="card-title align-items-start flex-column">
                            <span class="card-label fw-bold text-gray-900">Suggestions for you</span>
                            <span class="text-muted mt-1 fw-semibold fs-7">8k social visitors</span>
                        </h3>                        
                    </div>
                    <!--end::Header-->
                    <!--begin::Body-->
                    <div class="card-body pt-5">                        
                    </div>
                    <!--end::Body-->
                </div>
            </div>
        </div>
    </div>

`;
           




export default view;